// RTCCO clause 4 (fuel cost recovery) status — single source of truth.
//
// The MSO Tracker page (src/pages/MSOPage.jsx) maintains the RTCCO instrument,
// including the `clause4Active` flag on its registry entry. The Fuel Workbench
// reads this flag to decide whether the fortnightly fuel pass-through is a live
// obligation or dormant.
//
// As at 10 Jul 2026 clause 4 is SUSPENDED: the weekly average national terminal
// gate diesel price fell below $2.00/L (week ending 5 Jun 2026), so the Expert
// Panel confirmed the clause 4 obligations no longer apply. It reactivates if
// diesel rises back above the trigger — flip the flag on the MSO Tracker then.

const MSO_STORAGE_KEY = 'hp-msos';
const RTCCO_ID = 'rtcco-2026';

// Pass-through runs ONLY when the RTCCO entry is explicitly flagged active.
// Anything else — flag false/absent, no RTCCO entry, no registry, parse error —
// is treated as suspended. This fails safe: no pass-through is calculated or
// staged while the obligation is dormant.
export function isClause4Active() {
  try {
    const raw = localStorage.getItem(MSO_STORAGE_KEY);
    if (!raw) return false;
    const msos = JSON.parse(raw);
    if (!Array.isArray(msos)) return false;
    const rtcco = msos.find(m => m.id === RTCCO_ID || (m.referenceNo || '').toUpperCase().startsWith('RTCCO'));
    return rtcco?.clause4Active === true;
  } catch { return false; }
}
